import { useContext } from 'react';

import { TableRow, TableCell, Avatar } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { DashboardContext } from '../../../context/DashboardContext';
import { getTimeMetric } from '../getTimeMetric';
import { type StudentMetricsRow } from '../types';

const BodyCell = styled(TableCell)`
    padding: 0.25rem;
`;

const StudentBodyCell = styled(TableCell)`
    background-color: #f9fafa;
    position: sticky;
    left: 0;
`;

const UserDiv = styled.div`
    display: flex;
    align-items: center;
`;

const NameDiv = styled.div`
    margin-left: 10px;
`;

interface TableRowProps {
    row: StudentMetricsRow;
}

const DashboardTableRow: React.FC<TableRowProps> = (props) => {
    const { name, role, talkTime, focusTime, handRaisedCount, feedbackCount, starsMax } = props.row;
    const { metricTranslations, schoolSettings } = useContext(DashboardContext);
    const { t: tGeneric } = useTranslation('generic');

    const getInitials = (nameString) => {
        const names = nameString.split(' ');
        return names.length > 2 ? `${names[0].charAt(0).toUpperCase()}${names[1].charAt(0).toUpperCase()}` : names[0].charAt(0).toUpperCase();
    };
    return (
        <TableRow>
            <StudentBodyCell>
                <UserDiv>
                    <Avatar alt={name}>{getInitials(name)}</Avatar>
                    <NameDiv data-testid="name">{name}</NameDiv>
                </UserDiv>
            </StudentBodyCell>
            <BodyCell align="center" data-testid="role">{tGeneric(
                role.toLowerCase().replace(/\b[a-z]/g, (firstLetter) => firstLetter.toUpperCase())
            )}</BodyCell>
            <BodyCell align="center" data-testid="talk-time">{getTimeMetric(talkTime, metricTranslations)}</BodyCell>
            {schoolSettings.has_lose_focus_tracking && <BodyCell align="center" data-testid="focus-time">{getTimeMetric(focusTime, metricTranslations)}</BodyCell>}
            <BodyCell align="center" data-testid="hand-raises">{handRaisedCount}</BodyCell>
            <BodyCell align="center" data-testid="feedbacks">{feedbackCount}</BodyCell>
            <BodyCell align="center" data-testid="stars">{starsMax}</BodyCell>
        </TableRow>
    );
};

export default DashboardTableRow;
